import Api, { HealthCenter, Unit } from '@silbo/core';

export const getHealthCenterUnitsQuery = (healthCenter: HealthCenter) =>
  new Api.Query(Unit)
    .equalTo('healthCenter', healthCenter)
    .select('name', 'usePeriodStart', 'usePeriodEnd', 'ignoredAt');
